import { observable } from '@legendapp/state';

export enum IUserDarkMode {
  NOT_SET = 'not_set',
  NOT_SET_USER = 'not_set_user',
  USER_SET = 'user_set',
  SYSTEM_SET = 'system_set',
}

export enum IStatus {
  BOOTSTRAPPING = 'bootstrapping',
  TRANSITION_BOOTSTRAPPING = 'transition_bootstrapping',
  IDLE = 'idle',
  LOAD_EMPTY = 'empty',
  RUNNING = 'running',
  CANCELED = 'canceled',
  FAILED = 'failed',
  UPDATING = 'updating',
  SEARCH_INACTIVE = 'search_inactive',
  SEARCH_DRY_RUN = 'search_dry_run',
  SEARCH_IDLE = 'search_idle',
  SEARCHING = 'searching',
  SEARCH_ERROR = 'search_error',
  SEARCH_DONE = 'search_done',
  GENERIC_ERROR = 'generic_error',
}

export interface IState {
  settings: {
    darkMode: IUserDarkMode;
    isAppBootstrapped: boolean;
    isFullWidthState: boolean;
  };
}

//----  global state ------
export const state$ = observable<IState>({
  settings: {
    darkMode: IUserDarkMode.NOT_SET,
    isAppBootstrapped: false,
    isFullWidthState: false,
  },
});

//----- page state ------

export interface ISearchState {
  searchTerm: string;
  pending: IStatus;
  tags: string[];
  entries: any[];
  searchCount: number;
}
interface IPageState {
  isCategoryFailedState: boolean;
  searchState: string;
  isOverlayActive: boolean;
  errorMessage: string | undefined;
  activeItem: {
    title: string | undefined;
    data: any | undefined;
  };
}

export const pageState$ = observable<IPageState>({
  isCategoryFailedState: false,
  searchState: '',
  isOverlayActive: false,
  errorMessage: '',
  activeItem: {
    title: undefined,
    data: undefined,
  },
});

//----overlay----

export interface IFetchOverlayItemData {
  title?: string;
  url: string;
  metadata?: {
    contentType: string;
    lastModified: Date;
    size: number;
  };
}

export interface IOverlayRaw {
  [id: string]: IFetchOverlayItemData;
}

export interface IOverlay {
  activeItem: IFetchOverlayItemData | null;
  activeItemId: string | null;
}

export const overlayState$ = observable<IOverlay>({
  activeItemId: null,
  activeItem: null,
});
